// import React from "react";
// import ReactDOM from "react-dom";
// import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11';
// import "./index.css";
// import App from "./App";
// import * as serviceWorker from "./serviceWorker";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from 'react-redux'
// import store from './redux/store/store';
// import { PersistGate } from 'redux-persist/integration/react'
// import Loader from './utils/loader';
// import 'react-toastify/dist/ReactToastify.css';
// import VideoState from "./contexts/VideoState";
// ReactDOM.render(
//   <Provider store={store().store}>
//     <PersistGate loading={<Loader/>} persistor={store().persistor}>
//       <BrowserRouter>
//         <VideoState>
//         <App />
//         </VideoState>
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>
//   ,
//   document.getElementById("root")
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();


import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./utils/loader";
import "react-toastify/dist/ReactToastify.css";
import VideoState from "./contexts/VideoState";
import { initAuthSession } from "./initAuthSession";
import { store, persistor } from "./redux/store/store";
// StylesProvider injectFirst ensures MUI v4 JSS styles are injected BEFORE
// MUI v5 Emotion styles in <head>, so v5 always wins specificity conflicts.
// Without this, JSS sometimes overrides Emotion on navigation, causing stale fonts/styles.
import { StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import responsiveTheme from "./theme/responsiveTheme";

initAuthSession();

// "ResizeObserver loop ..." is a benign browser notice (layout settled one
// frame late), but CRA's dev overlay reports it as a runtime error. Swallow
// only that message so real errors still surface.
const RESIZE_OBSERVER_ERROR =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (event) => {
  if (RESIZE_OBSERVER_ERROR.test(event.message)) {
    event.stopImmediatePropagation();
    // If the dev-server overlay already rendered for this event, hide it.
    const overlay = document.getElementById(
      "webpack-dev-server-client-overlay"
    );
    const overlayDiv = document.getElementById(
      "webpack-dev-server-client-overlay-div"
    );
    if (overlay) overlay.style.display = "none";
    if (overlayDiv) overlayDiv.style.display = "none";
  }
});

ReactDOM.render(
  <StylesProvider injectFirst>
    <MuiThemeProvider theme={responsiveTheme}>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <BrowserRouter>
            <VideoState>
              <App />
            </VideoState>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </MuiThemeProvider>
  </StylesProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
